import axios from "axios";

// Same-origin in production, on purpose.
//
// Organisation ranking pages are served on their own custom domains, and their
// API calls have to land on the domain they were made from - that Host header
// is what tells the server which organisation the page belongs to. An absolute
// URL baked in at build time would send every one of them to the main domain
// instead, and every page would resolve to no organisation.
const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production" ? "/api" : "http://localhost:3002/api");

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Store getAccessToken function reference (will be set from App.js)
let getAccessTokenFn = null;

export function setTokenGetter(fn) {
  getAccessTokenFn = fn;
}

// Request interceptor to get fresh token before each request
axiosClient.interceptors.request.use(
  async (config) => {
    try {
      // Get fresh token from Kinde before each request
      if (getAccessTokenFn) {
        const token = await getAccessTokenFn();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (error) {
      console.error("Failed to get access token:", error);
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor to handle auth errors
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Let the app handle the logout - dispatch event for listeners
      window.dispatchEvent(new CustomEvent("auth-unauthorized"));
    }
    return Promise.reject(error);
  },
);

export default axiosClient;
